import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import SearchResultsSkeletonSegment from '@src/components/SearchResultsSkeletonSegment'

export const useStyles = makeStyles()((theme) => {
  return {
    root: {
      marginBottom: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      borderBottom: `1px solid ${theme.palette.grey[300]}`,
      '&:first-of-type': {
        paddingTop: theme.spacing(4),
        borderTop: `1px solid ${theme.palette.grey[300]}`,
      },
    },
  }
})

const ContentSearchResultsSkeleton = () => {
  const { classes } = useStyles()
  return (
    <div data-testid="site-content-srp-skeleton">
      <Box mb={4} />
      <div>
        {Array(5)
          .fill({})
          .map((_, index) => (
            <div key={index} className={classes.root}>
              <SearchResultsSkeletonSegment height={28} width={0.7} mb={4} />
              <SearchResultsSkeletonSegment height={16} width={0.95} mb={3} />
              <SearchResultsSkeletonSegment height={16} width={0.75} />
            </div>
          ))}
      </div>
    </div>
  )
}

export default ContentSearchResultsSkeleton
